module.exports = __webpack_public_path__ + "static/media/web2.9c9e53ab.svg";